import { render, staticRenderFns } from "./event_change_notify.vue?vue&type=template&id=aed8b8cc&"
import script from "./event_change_notify.vue?vue&type=script&lang=js&"
export * from "./event_change_notify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports